import { selectors } from 'modules/common';
import { domain } from 'modules/data';

import { TemplateReference } from '../../types/TemplateReference';
import { otherWorkflows } from './mapReportList.constants';
import { messages } from './mapReportList.messages';

export const mapReportList = (
    templates: selectors.types.ExpandedTemplate[],
    reportType: domain.ReportType | undefined
) => {
    const reportList: TemplateReference[] = [];

    const isLineItemReport = reportType === domain.ReportType.LineItem;

    templates.forEach((template) => {
        if (!template.integrationCode) {
            reportList.push({
                id: template.id,
                text: template.displayName,
                integrationCode: null,
                otherWorkflow: false,
            });

            return;
        }

        if (isLineItemReport && template.integrationCode === domain.IntegrationCode.NetSuiteBill) {
            reportList.push(
                {
                    id: domain.ReportCode.NetSuiteVendorBillItemLine,
                    text: messages.netSuiteVendorBillItemLine,
                    integrationCode: template.integrationCode,
                    lineItemCode: domain.ReportCode.NetSuiteVendorBillItemLine,
                    otherWorkflow: false,
                },
                {
                    id: domain.ReportCode.NetSuiteVendorBillExpenseLine,
                    text: messages.netSuiteVendorBillExpenseLine,
                    integrationCode: template.integrationCode,
                    lineItemCode: domain.ReportCode.NetSuiteVendorBillExpenseLine,
                    otherWorkflow: false,
                }
            );

            return;
        }

        reportList.push({
            id: template.integrationCode,
            text: template.displayName,
            integrationCode: template.integrationCode,
            lineItemCode: selectors.report.getLineItemTypeByIntegrationCode(template.integrationCode),
            otherWorkflow: otherWorkflows.includes(template.integrationCode),
        });
    });

    return reportList;
};
